define(["require", "exports", "knockout", "../utils/tools", "../utils/dateUtils"], function (require, exports, ko, tools, dateUtils) {
    "use strict";
    var CustomerNoteModel = /** @class */ (function () {
        function CustomerNoteModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.CreatedBy = ko.observable(0);
            this.Notes = ko.observable();
            this.CreatedDateTime = ko.observable(new Date());
            this.CreatedDateTimeStr = ko.observable("");
            this.NoteType = ko.observable("Notes");
            this.UserName = ko.observable();
            this.ToDoId = ko.observable();
            this.CategoryId = ko.observable();
            this.ContactId = ko.observable();
            this.NotificationType = ko.observable();
            this.IsImportant = ko.observable();
            this.ExpirationDate = ko.observable(new Date());
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerNoteModel.Mapping, self);
            }
            self.NotesWithUrls = ko.computed(function () {
                return tools.urlify(self.Notes());
            });
        }
        CustomerNoteModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerNoteModel(options.data);
            },
            ExpirationDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return CustomerNoteModel;
    }());
    return CustomerNoteModel;
});
//# sourceMappingURL=CustomerNoteModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerNoteModel.js
// module id = 157
// module chunks = 2